import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TSwiperWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import _ from "lodash";
import {EventType} from "../../../constants/AppsmithActionConstants/ActionConstants";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TSwiper extends TaroWidget<TSwiperWidgetProps, WidgetState> {
  constructor(props: TSwiperWidgetProps) {
    super(props);
    this.onItemClick = this.onItemClick.bind(this);
  }

  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;


  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
    };
  }

  static getMetaPropertiesMap(): Record<string, any> {
    return {
      isDirty: false,
      value: undefined
    };
  }
  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`
    };
  }

  updateWidgetProperty = (propertyValues: string) => {
    if (!this.props.isDirty) {
      this.props.updateWidgetMetaProperty("isDirty", true);
    }
    this.props.updateWidgetMetaProperty("value", propertyValues);
  }
  onItemClick(item: any) {
    let url = item.topage ? item.topage : item.toUrl;
    let linkParams = _.isEmpty(item.linkParams) || {};
    url && super.executeAction({
      triggerPropertyName: "onClick",
      dynamicString: `{{navigateTo("${url}", ${linkParams}, "${item.topagetype}")}}`,
      event: {
        type: EventType.ON_CLICK
      },
    });
  }
  getPageView() {
    return (
      <TSwiperWidget {...this.props} onItemClick={this.onItemClick} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_SWIPER_WIDGET";
  }
}

export interface TSwiperWidgetProps extends WidgetProps {
  value: any[];
  enableDownload?: boolean;
  enableRotation?: boolean;
  onClick?: string;
  borderRadius: string;
  boxShadow?: string;
}

export default TSwiper;
